import { loadNetworkTopicSettings } from '@ms/yammer-data/dist/domains/networkTopicSettings/actions';
import type { ThunkDispatch } from '@ms/yammer-data/dist/types';
import { reportError } from '@ms/yammer-telemetry';
import { getNetworkTopicSettingsApiCaching } from 'domains/teams/apiCaching';
import { getHostClientType } from 'state/teamsContext/selectors';
import type { YammerTeamsNativeState } from 'state/types';

type LoadBootstrapNetworkTopicSettings = (
  dispatch: ThunkDispatch<YammerTeamsNativeState>,
  getState: () => YammerTeamsNativeState
) => Promise<void>;
export const loadBootstrapNetworkTopicSettings: LoadBootstrapNetworkTopicSettings = async (dispatch) => {
  const hostClientType = getHostClientType();
  const caching = getNetworkTopicSettingsApiCaching('ReadCacheOrFetchAndWrite', hostClientType);

  try {
    await dispatch(loadNetworkTopicSettings({ initiator: 'bootstrap_async', caching }));
  } catch (error) {
    reportError({ error, eventProperties: { errorCode: 'NetworkTopicSettingsFailed' } });
  }
};
